import EmployeesConstants from '@/store/modules/usersManagement/employees/constants';
import UsersService from '@/services/usersService';
import RolesService from '@/services/rolesService';
import ClientsService from '@/services/clientsService';

const usersService = new UsersService();
const rolesService = new RolesService();
const clientsService = new ClientsService();

export default {
  [EmployeesConstants.actionTypes.loadEmployees]({
    commit,
    state,
  }) {
    const {
      pageNumber,
      pageSize,
      sortBy,
      sortOrder,
    } = state.paginationInfo;
    const { filterQuery } = state;

    commit(EmployeesConstants.mutationTypes.setIsLoading, true);
    usersService
      .getEmployees({
        pageNumber,
        pageSize,
        sortBy,
        sortOrder,
        filterQuery,
      })
      .then((apiResponse) => {
        if (apiResponse) {
          if (apiResponse === null) {
            commit(EmployeesConstants.mutationTypes.setEmployees, []);
            commit(EmployeesConstants.mutationTypes.setEmployeesTotal, 0);
          } else {
            commit(EmployeesConstants.mutationTypes.setEmployees, apiResponse.items);
            commit(EmployeesConstants.mutationTypes.setEmployeesTotal, apiResponse.total);
          }
          commit(EmployeesConstants.mutationTypes.setIsLoading, false);
        }
      })
      .catch(() => {
        commit(EmployeesConstants.mutationTypes.setEmployees, []);
        commit(EmployeesConstants.mutationTypes.setEmployeesTotal, 0);
        commit(EmployeesConstants.mutationTypes.setIsLoading, false);
      });
  },

  [EmployeesConstants.actionTypes.updatePaginationInfo]({
    commit,
    dispatch,
  }, paginationInfo) {
    commit(EmployeesConstants.mutationTypes.setPaginationInfo, paginationInfo);

    dispatch(EmployeesConstants.actionTypes.loadEmployees);
  },

  [EmployeesConstants.actionTypes.onFilterQueryChanged]({
    commit,
    dispatch,
  }, newValue) {
    commit(EmployeesConstants.mutationTypes.setFilterQuery, newValue);
    commit(EmployeesConstants.mutationTypes.setPaginationInfoPageNumber, 1);

    dispatch(EmployeesConstants.actionTypes.loadEmployees);
  },

  [EmployeesConstants.actionTypes.addNewEmployee]({
    commit, dispatch,
  }, newEmployee) {
    return usersService
      .addEmployee(newEmployee)
      .then((data) => {
        commit(EmployeesConstants.mutationTypes.setIsLoading, true);

        dispatch(EmployeesConstants.actionTypes.loadEmployees);

        return Promise.resolve(data);
      })
      .catch(err => Promise.reject(err));
  },

  [EmployeesConstants.actionTypes.updateEmployee]({
    commit, dispatch,
  }, employee) {
    return usersService
      .updateEmployee(employee)
      .then((data) => {
        commit(EmployeesConstants.mutationTypes.setIsLoading, true);

        dispatch(EmployeesConstants.actionTypes.loadEmployees);

        return Promise.resolve(data);
      })
      .catch(err => Promise.reject(err));
  },

  [EmployeesConstants.actionTypes.loadRoles]({
    commit,
  }) {
    rolesService
      .getRoles().then((roles) => {
        const SUPPLIER_ROLE_ID = 1;
        const rolesWithoutSupplier = roles.filter(role => role.id !== SUPPLIER_ROLE_ID);
        commit(EmployeesConstants.mutationTypes.setRoles, rolesWithoutSupplier);
      });
  },

  [EmployeesConstants.actionTypes.loadManagers]({
    commit,
  }) {
    usersService
      .getManagers().then((managers) => {
        commit(EmployeesConstants.mutationTypes.setManagers, managers);
      });
  },

  [EmployeesConstants.actionTypes.loadClients]({
    commit,
  }) {
    clientsService
      .getClients().then((clients) => {
        commit(EmployeesConstants.mutationTypes.setClients, clients);
      });
  },

  [EmployeesConstants.actionTypes.resendEmailVerification](vuexObj, employeeInfo) {
    return usersService
      .resendEmployeeEmailVerification(employeeInfo)
      .then(data => Promise.resolve(data))
      .catch(err => Promise.reject(err));
  },
};
